import { useState } from "react";
import * as Helper from "./FailureStateHelper";

export interface FailureStatePageProps {
  errorToUse?: Error | string;
  homepageUrl?: string;
  isConsoleErrorEnabled?: boolean;
}

export function FailureStatePage({
  errorToUse,
  homepageUrl,
  isConsoleErrorEnabled = true
}: FailureStatePageProps) {
  const [showError, setShowError] = useState(false);

  const onHomeClick = () => {
    if (homepageUrl) {
      window.location.href = homepageUrl;
    } else {
      window.location.hash = "";
      window.location.reload();
    }
  };
  return (
    <Helper.StyledFailureState>
      <Helper.StyledFailureStateContent>
        <Helper.StyledHeader>
          <Helper.GrownFlex>
            <Helper.WarningIcon title="Application Error icon" />
          </Helper.GrownFlex>
          <Helper.StyledHeaderText>Application Error</Helper.StyledHeaderText>
          <Helper.GrownFlex>
            <Helper.WarningIcon title="Application Error icon" />
          </Helper.GrownFlex>
        </Helper.StyledHeader>
        <Helper.StyledSubHeader>
          We&apos;re sorry, The application has encountered an error and
          isn&apos;t currently available. Select Home to return and try again
          later. <br />
          {errorToUse && (
            <>
              Your error message is:
              <Helper.StyledErrorMessage>
                {Helper.getErrorMessage(errorToUse)}
              </Helper.StyledErrorMessage>
            </>
          )}
        </Helper.StyledSubHeader>
        <Helper.CenteredFlex>
          {errorToUse && isConsoleErrorEnabled && !showError && (
            <Helper.GrownFlex>
              <Helper.StyledShowErrorButton
                analyticsConfiguration={{
                  eventName: "Show Error"
                }}
                buttonStyle="aux"
                onClick={() => {
                  setShowError(true);
                }}
              >
                Error Details
              </Helper.StyledShowErrorButton>
            </Helper.GrownFlex>
          )}
          <Helper.GrownFlex>
            <Helper.StyledReturnButton
              analyticsConfiguration={{
                eventName: "Return"
              }}
              buttonStyle="primary"
              onClick={onHomeClick}
            >
              {homepageUrl ? "Home" : "Refresh"}
            </Helper.StyledReturnButton>
          </Helper.GrownFlex>
        </Helper.CenteredFlex>
        {showError && errorToUse && (
          <Helper.StyledErrorMessage>
            {Helper.getStackTraceMessage(errorToUse)}
          </Helper.StyledErrorMessage>
        )}
      </Helper.StyledFailureStateContent>
    </Helper.StyledFailureState>
  );
}

export default FailureStatePage;
